// src/components/StockSummaryPage.jsx
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import useEscapeToGoBack from "../hooks/useEscapeToGoBack";
import "./Renew.css"; // reuse Renew page styling

const API_BASE = "https://www.lianfoong.com/api/pawn-transactions";

const StockSummaryPage = () => {
  useEscapeToGoBack();
  const navigate = useNavigate();

  const [staffName, setStaffName] = useState("");
  const [month, setMonth] = useState("");    // we’ll send UPPERCASE to backend
  const [year, setYear] = useState(new Date().getFullYear());
  const [downloading, setDownloading] = useState(false);

  const staffRef = useRef(null);

  useEffect(() => {
    // autofocus staff on mount
    requestAnimationFrame(() => {
      staffRef.current?.focus();
      staffRef.current?.select?.();
    });
  }, []);

  // Use display labels but store uppercase values (backend accepts .toUpperCase())
  const months = [
    { label: "Select Month", value: "" },
    { label: "January",   value: "JANUARY" },
    { label: "February",  value: "FEBRUARY" },
    { label: "March",     value: "MARCH" },
    { label: "April",     value: "APRIL" },
    { label: "May",       value: "MAY" },
    { label: "June",      value: "JUNE" },
    { label: "July",      value: "JULY" },
    { label: "August",    value: "AUGUST" },
    { label: "September", value: "SEPTEMBER" },
    { label: "October",   value: "OCTOBER" },
    { label: "November",  value: "NOVEMBER" },
    { label: "December",  value: "DECEMBER" },
  ];

  const downloadBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(url);
    a.remove();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!staffName || !month || !year) return;

    setDownloading(true);
    try {
      // New Excel endpoint you exposed
      const resp = await axios.get(`${API_BASE}/pawnshop-report-xls`, {
        params: { staffName, month, year },   // month already uppercase from select
        responseType: "blob",
      });

      // If server returned a text error (e.g. 400 with text/plain)
      if (resp.data && resp.data.type && resp.data.type.includes("text")) {
        const msg = await resp.data.text();
        alert(msg || "Error generating report.");
        return;
      }

      // Save as .xls (or .xlsx if your template is xlsx; just change extension)
      downloadBlob(resp.data, `pawnshop_report_${month}_${year}.xls`);
    } catch (err) {
      console.error(err);
      alert("Failed to generate report.");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="renew-container">
      <h2 className="title">Pawnshop Monthly Report</h2>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Staff Name:</label>
          <input
            ref={staffRef}
            type="text"
            value={staffName}
            onChange={(e) => setStaffName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Month:</label>
          <select value={month} onChange={(e) => setMonth(e.target.value)} required>
            {months.map((m) => (
              <option key={m.value || "none"} value={m.value} disabled={!m.value}>
                {m.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Year:</label>
          <input
            type="number"
            value={year}
            min="2020"
            max="2099"
            onChange={(e) => setYear(e.target.value)}
            required
          />
        </div>

        <button className="search-btn" type="submit" disabled={downloading}>
          {downloading ? "Generating…" : "Generate Excel"}
        </button>

        <button
          type="button"
          className="next-btn"
          onClick={() => navigate("/other")}
          style={{ marginTop: 10 }}
        >
          Back
        </button>
      </form>
    </div>
  );
};

export default StockSummaryPage;
